import styled from 'styled-components';
import { COLOR } from '@src/styles/color';
import { TRACK_HEIGHT } from '@src/constants/timeline';

export const StyledLane = styled.div`
  position: relative;
  width: 100%;
  height: ${TRACK_HEIGHT}px;
`;

// Time readout shown at the top of the lane, centred over the clip being
// dragged/trimmed. Lives in the lane (not the clip, whose overflow:hidden would
// clip it) so it stays fully visible even when the clip is trimmed very narrow.
export const StyledDragTooltip = styled.span`
  position: absolute;
  top: -6px;
  left: ${({ left }) => left}px;
  transform: translateX(-50%);
  z-index: 3;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: ${COLOR.darkBlue};
  color: ${COLOR.white};
  font-size: 10px;
  line-height: 14px;
  white-space: nowrap;
  pointer-events: none;
`;

export const StyledAppendWrap = styled.div`
  position: absolute;
  top: 50%;
  left: ${({ left }) => left}px;
  transform: translateY(-50%);
  padding-right: 8px;
`;
